(() => {
  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const DEFAULT_ROWS = [
    ['male', 'XXS', 158, 164, 48, 58],
    ['male', 'XS', 164, 169, 55, 66],
    ['male', 'S', 170, 175, 62, 74],
    ['male', 'M', 176, 180, 69, 82],
    ['male', 'L', 181, 187, 77, 92],
    ['male', 'XL', 188, 196, 87, 105],
    ['male', 'XXL', 197, 202, 99, 120],
    ['female', 'XXS', 150, 158, 40, 49],
    ['female', 'XS', 154, 164, 46, 56],
    ['female', 'S', 160, 170, 52, 64],
    ['female', 'M', 165, 176, 59, 74],
    ['female', 'L', 168, 182, 68, 85],
    ['female', 'XL', 170, 188, 78, 98],
    ['female', 'XXL', 172, 194, 90, 115]
  ].map(([gender, size, heightMin, heightMax, weightMin, weightMax]) => ({
    gender,
    size,
    heightMin,
    heightMax,
    weightMin,
    weightMax
  }));

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const number = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  const normalizeSize = (value) => String(value || '').trim().toUpperCase().replace('2XS', 'XXS').replace('2XL', 'XXL');
  const rangeDistance = (value, min, max) => {
    if (!Number.isFinite(value) || !Number.isFinite(min) || !Number.isFinite(max) || max <= min) return 0;
    const span = max - min;
    const midpoint = min + span / 2;
    const outside = value < min ? (min - value) / span : value > max ? (value - max) / span : 0;
    const center = Math.abs(value - midpoint) / span;
    return outside * 3 + center * .14;
  };

  class ScrptdFitQuiz {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('[data-fit-dialog]');
      this.triggerWrap = root.querySelector('[data-fit-trigger-wrap]');
      this.trigger = root.querySelector('[data-fit-open]');
      this.back = root.querySelector('[data-fit-back]');
      this.close = root.querySelector('[data-fit-close]');
      this.progress = root.querySelector('[data-fit-progress]');
      this.progressText = root.querySelector('[data-fit-progress-text]');
      this.screens = Array.from(root.querySelectorAll('[data-fit-screen]'));
      this.resultScreen = root.querySelector('[data-fit-result]');
      this.resultSize = root.querySelector('[data-fit-result-size]');
      this.resultCopy = root.querySelector('[data-fit-result-copy]');
      this.config = this.readConfig();
      this.step = 0;
      this.state = {};
      this.recommendedSize = '';
      this.form = null;
      if (!this.dialog || !this.trigger) return;
      this.placeTrigger();
      this.bind();
      this.syncRanges();
      this.showStep(0);
    }

    readConfig() {
      const node = this.root.querySelector('[data-fit-config]');
      try {
        return JSON.parse(node?.textContent || '{}');
      } catch (error) {
        console.warn('SCRPTD Fit Quiz: Konfiguration konnte nicht gelesen werden.', error);
        return { rows: [], weights: {}, offsets: {}, copy: {} };
      }
    }

    placeTrigger() {
      const optionList = document.querySelector('[data-node-type="add-to-cart-option-list"]');
      const firstSizeGrid = document.querySelector('[data-scrptd-product-sizes]');
      const target = optionList || firstSizeGrid;
      if (target && this.triggerWrap) {
        target.after(this.triggerWrap);
        this.form = this.triggerWrap.closest('form');
      }
      if (!this.form) this.form = document.querySelector('form[action*="/cart/add"]');
    }

    bind() {
      this.trigger.addEventListener('click', () => this.open());
      this.close?.addEventListener('click', () => this.dialog.close());
      this.back?.addEventListener('click', () => this.showStep(Math.max(0, this.step - 1)));
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('scrptd-fit-quiz-open');
        this.trigger.focus({ preventScroll: true });
      });
      this.dialog.addEventListener('cancel', () => document.body.classList.remove('scrptd-fit-quiz-open'));

      this.root.addEventListener('click', (event) => {
        const answer = event.target.closest('[data-fit-answer]');
        if (answer) this.answer(answer);
        const next = event.target.closest('[data-fit-next]');
        if (next) this.advanceFromRange(next);
        if (event.target.closest('[data-fit-restart]')) this.reset();
        if (event.target.closest('[data-fit-apply]')) this.applyRecommendation();
      });

      this.root.querySelectorAll('[data-fit-range]').forEach((range) => {
        range.addEventListener('input', () => this.syncRange(range));
      });
    }

    open() {
      this.reset(false);
      document.body.classList.add('scrptd-fit-quiz-open');
      this.dialog.showModal();
    }

    reset(focus = true) {
      this.state = {};
      this.recommendedSize = '';
      this.root.querySelectorAll('.is-selected').forEach((node) => node.classList.remove('is-selected'));
      this.root.querySelectorAll('[data-fit-range]').forEach((range) => {
        range.value = range.dataset.default || range.min;
        this.syncRange(range);
      });
      this.showStep(0);
      if (focus && this.dialog.open) this.screens[0]?.querySelector('button')?.focus();
    }

    showStep(index) {
      this.step = clamp(index, 0, 6);
      this.screens.forEach((screen, screenIndex) => {
        const active = screenIndex === this.step;
        screen.classList.toggle('is-active', active);
        screen.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.resultScreen?.classList.remove('is-active');
      this.resultScreen?.setAttribute('aria-hidden', 'true');
      if (this.back) this.back.hidden = this.step === 0;
      if (this.progress) this.progress.style.setProperty('--fit-progress', `${((this.step + 1) / 7) * 100}%`);
      if (this.progressText) this.progressText.textContent = `${this.step + 1}/7`;
      window.setTimeout(() => this.screens[this.step]?.querySelector('button, input')?.focus({ preventScroll: true }), 30);
    }

    answer(button) {
      const key = button.dataset.fitAnswer;
      const value = button.dataset.fitValue;
      if (!key) return;
      this.state[key] = value;
      if (key === 'gender') this.applyGenderDefaults(value);
      const screen = button.closest('[data-fit-screen]');
      screen?.querySelectorAll(`[data-fit-answer="${key}"]`).forEach((item) => item.classList.toggle('is-selected', item === button));
      window.setTimeout(() => {
        if (this.step === 6) this.finish();
        else this.showStep(this.step + 1);
      }, 110);
    }

    applyGenderDefaults(gender) {
      const defaults = this.config.defaults || {};
      const height = this.root.querySelector('[data-fit-range="height"]');
      const weight = this.root.querySelector('[data-fit-range="weight"]');
      if (height) {
        height.value = gender === 'female' ? number(defaults.femaleHeight, 168) : number(defaults.maleHeight, 178);
        this.syncRange(height);
      }
      if (weight) {
        weight.value = gender === 'female' ? number(defaults.femaleWeight, 62) : number(defaults.maleWeight, 75);
        this.syncRange(weight);
      }
    }

    advanceFromRange(button) {
      const screen = button.closest('[data-fit-screen]');
      const range = screen?.querySelector('[data-fit-range]');
      if (!range) return;
      this.state[range.dataset.fitRange] = number(range.value);
      this.showStep(this.step + 1);
    }

    syncRanges() {
      this.root.querySelectorAll('[data-fit-range]').forEach((range) => this.syncRange(range));
    }

    syncRange(range) {
      const output = this.root.querySelector(`[data-fit-range-output="${range.dataset.fitRange}"]`);
      const min = number(range.min);
      const max = number(range.max, 100);
      const value = number(range.value, min);
      const progress = max === min ? 0 : ((value - min) / (max - min)) * 100;
      range.style.setProperty('--fit-range-progress', `${progress}%`);
      if (output) output.textContent = `${value} ${range.dataset.unit || ''}`.trim();
    }

    productOffset() {
      const offsets = this.config.offsets || {};
      const type = String(this.root.dataset.productType || '').toLowerCase();
      const tags = String(this.root.dataset.productTags || '').toLowerCase();
      let offset = number(offsets.default);
      if (type.includes('zip') || tags.includes('zip-hoodie')) offset += number(offsets.zipHoodie);
      else if (type.includes('hoodie') || tags.includes('hoodie')) offset += number(offsets.hoodie);
      else if (type.includes('jogger') || type.includes('pants') || tags.includes('jogger')) offset += number(offsets.jogger);
      else if (type.includes('shirt') || type.includes('tee') || tags.includes('t-shirt')) offset += number(offsets.tshirt);
      if (tags.includes('fit:oversized')) offset -= 1;
      if (tags.includes('fit:slim')) offset += 1;
      if (tags.includes('fit:regular')) offset += 0;
      offset += number(this.root.dataset.productOffset);
      return offset;
    }

    calculate() {
      const gender = this.state.gender || 'male';
      const configuredRows = Array.isArray(this.config.rows) ? this.config.rows : [];
      const rows = (configuredRows.length ? configuredRows : DEFAULT_ROWS)
        .filter((row) => row.gender === gender && SIZE_ORDER.includes(normalizeSize(row.size)))
        .sort((a, b) => SIZE_ORDER.indexOf(normalizeSize(a.size)) - SIZE_ORDER.indexOf(normalizeSize(b.size)));
      const height = number(this.state.height, gender === 'female' ? 168 : 178);
      const weight = number(this.state.weight, gender === 'female' ? 62 : 78);
      const usualIndex = SIZE_ORDER.indexOf(normalizeSize(this.state.usualSize));
      const weights = this.config.weights || {};
      const heightWeight = number(weights.height, .5);
      const bodyWeight = number(weights.weight, .25);
      const usualWeight = number(weights.usual, .25);

      let bestIndex = usualIndex >= 0 ? usualIndex : 3;
      let bestScore = Number.POSITIVE_INFINITY;
      rows.forEach((row) => {
        const index = SIZE_ORDER.indexOf(normalizeSize(row.size));
        const score = rangeDistance(height, number(row.heightMin), number(row.heightMax)) * heightWeight
          + rangeDistance(weight, number(row.weightMin), number(row.weightMax)) * bodyWeight
          + (usualIndex >= 0 ? Math.abs(index - usualIndex) * usualWeight : 0);
        if (score < bestScore) {
          bestScore = score;
          bestIndex = index;
        }
      });

      bestIndex += number(this.state.consistency) + number(this.state.bodyShape) + number(this.state.fit) + this.productOffset();
      bestIndex = clamp(Math.round(bestIndex), 0, SIZE_ORDER.length - 1);
      const ideal = SIZE_ORDER[bestIndex];
      return { ideal, available: this.closestAvailableSize(ideal) };
    }

    availableSizes() {
      const cells = Array.from(document.querySelectorAll('[data-scrptd-product-sizes] [data-scrptd-size-value]'));
      return [...new Set(cells.filter((cell) => !cell.disabled && cell.getAttribute('aria-disabled') !== 'true').map((cell) => normalizeSize(cell.textContent)))];
    }

    closestAvailableSize(size) {
      const available = this.availableSizes();
      if (!available.length || available.includes(size)) return size;
      const target = SIZE_ORDER.indexOf(size);
      return available.sort((a, b) => Math.abs(SIZE_ORDER.indexOf(a) - target) - Math.abs(SIZE_ORDER.indexOf(b) - target))[0] || size;
    }

    finish() {
      const recommendation = this.calculate();
      this.recommendedSize = recommendation.available;
      this.step = 7;
      this.screens.forEach((screen) => {
        screen.classList.remove('is-active');
        screen.setAttribute('aria-hidden', 'true');
      });
      if (this.resultSize) this.resultSize.textContent = this.recommendedSize;
      if (this.resultCopy) {
        const unavailableCopy = this.config.copy?.availabilityFallback || '';
        this.resultCopy.textContent = recommendation.ideal === recommendation.available || !unavailableCopy
          ? (this.config.copy?.result || this.resultCopy.textContent)
          : unavailableCopy.replace('[size]', this.recommendedSize);
      }
      this.resultScreen?.classList.add('is-active');
      this.resultScreen?.setAttribute('aria-hidden', 'false');
      if (this.back) this.back.hidden = false;
      if (this.progress) this.progress.style.setProperty('--fit-progress', '100%');
      if (this.progressText) this.progressText.textContent = '7/7';
      window.setTimeout(() => this.resultScreen?.querySelector('[data-fit-apply]')?.focus({ preventScroll: true }), 30);
    }

    selectRecommendedSize() {
      if (!this.recommendedSize) return false;
      const desired = normalizeSize(this.recommendedSize);
      let selected = false;
      document.querySelectorAll('[data-scrptd-product-sizes]').forEach((group) => {
        const exact = Array.from(group.querySelectorAll('[data-scrptd-size-value]')).find((cell) => !cell.disabled && normalizeSize(cell.textContent) === desired);
        if (exact) {
          exact.click();
          selected = true;
        }
      });
      return selected;
    }

    applyRecommendation() {
      const selected = this.selectRecommendedSize();
      this.dialog.close();
      if (!selected) return;
      window.setTimeout(() => {
        const submit = this.form?.querySelector('[data-scrptd-product-submit], [data-node-type="commerce-add-to-cart-button"]');
        if (submit && !submit.disabled) submit.click();
      }, 140);
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-scrptd-fit-quiz]:not([data-fit-initialized])').forEach((root) => {
      root.dataset.fitInitialized = 'true';
      new ScrptdFitQuiz(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
